var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 73,
    viewBox: "0 0 63 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H22.39L16.89 49.4H5.71L0 0Z",
    fill: "#9BBCFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1894 72.6198C16.2041 72.6198 20.2694 68.5187 20.2694 63.4598C20.2694 58.4009 16.2041 54.2998 11.1894 54.2998C6.17463 54.2998 2.10938 58.4009 2.10938 63.4598C2.10938 68.5187 6.17463 72.6198 11.1894 72.6198Z",
    fill: "#9BBCFB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4902 0H61.8702L56.3802 49.4H45.1902L39.4902 0Z",
    fill: "#9BBCFB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6796 72.6198C55.6944 72.6198 59.7596 68.5187 59.7596 63.4598C59.7596 58.4009 55.6944 54.2998 50.6796 54.2998C45.6649 54.2998 41.5996 58.4009 41.5996 63.4598C41.5996 68.5187 45.6649 72.6198 50.6796 72.6198Z",
    fill: "#9BBCFB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMark);
export default __webpack_public_path__ + "static/media/logo-mark.f9a8d0b0.svg";
export { ForwardRef as ReactComponent };